import * as yup from 'yup';
import { ValidationConstants } from 'helpers/constants';
import { IntlShape } from 'react-intl';
import {
  DEFAULT_MIN_PASSWORD_LENGTH_MESSAGE,
  DEFAULT_PASSWORDS_DONT_MATCH_MESSAGE,
  DEFAULT_PASSWORD_REQUIRED_MESSAGE,
  DEFAULT_REPEAT_PASSWORD_REQUIRED_MESSAGE,
} from './constants';
import messages from './messages';
import { formatMessage } from 'helpers/intl';

export const getPasswordSettingsSchema = (intl?: IntlShape) =>
  yup.object({
    password: yup
      .string()
      .min(
        ValidationConstants.MIN_PASSWORD_LENGTH,
        formatMessage(
          intl,
          messages.minPasswordLength,
          DEFAULT_MIN_PASSWORD_LENGTH_MESSAGE
        )
      )
      .required(
        formatMessage(
          intl,
          messages.passwordRequired,
          DEFAULT_PASSWORD_REQUIRED_MESSAGE
        )
      ),
    passwordRepeat: yup
      .string()
      .oneOf(
        [yup.ref('password')],
        formatMessage(
          intl,
          messages.passwordsDontMatch,
          DEFAULT_PASSWORDS_DONT_MATCH_MESSAGE
        )
      )
      .required(
        formatMessage(
          intl,
          messages.repeatPasswordRequired,
          DEFAULT_REPEAT_PASSWORD_REQUIRED_MESSAGE
        )
      ),
  });
